import { render, staticRenderFns } from "./jiucuo.vue?vue&type=template&id=0e8adc33&scoped=true&"
import script from "./jiucuo.vue?vue&type=script&lang=js&"
export * from "./jiucuo.vue?vue&type=script&lang=js&"
import style0 from "./jiucuo.vue?vue&type=style&index=0&id=0e8adc33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8adc33",
  null
  
)

export default component.exports